import Model from '../../../../utils/Model'
import HTTPService from '../../HTTPService'

class WidgetsService extends Model {
  getAll (companySlug) {
    return HTTPService.get(`company/${companySlug}/widget`)
  }

  getOne (companySlug, widgetSlug) {
    return HTTPService.get(`company/${companySlug}/widget/${widgetSlug}`)
  }

  addOne (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/widget`, {
      name: payload.name,
      description: payload.description
    })
  }

  updateOne (companySlug, widgetSlug, payload) {
    return HTTPService.put(`company/${companySlug}/widget/${widgetSlug}`, payload)
  }

  deleteOne (companySlug, widgetSlug) {
    return HTTPService.delete(`company/${companySlug}/widget/${widgetSlug}`)
  }

  getTransports (companySlug) {
    return HTTPService.get(`company/${companySlug}/widget/transport`)
  }
}

export default new WidgetsService()
